export const SESSION_TIMEOUT_CONTENT = Object.freeze({
    HEADER : "You have been idle for longer time!",
    BODY_CONTENT_BEFORE_TIMEOUT_FIRST : "Your session is going to expire in ",
    BODY_CONTENT_BEFORE_TIMEOUT_SECOND : " seconds",
    BODY_CONTENT_AFTER_TIMEOUT : "Your session is expired.",
})